import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ms: {
    translation: {
      app_name: "Rekod & Pengurusan Staff",
      welcome: "Selamat Datang",
      loading: "Memuatkan...",
      save: "Simpan",
      cancel: "Batal",
      delete: "Padam",
      edit: "Edit",
      add: "Tambah",
      search: "Cari",
      filter: "Tapis",
      export: "Eksport",
      download: "Muat Turun",
      close: "Tutup",
      submit: "Hantar",
      confirm: "Sahkan",
      back: "Kembali",
      next: "Seterusnya",
      yes: "Ya",
      no: "Tidak",
      all: "Semua",
      none: "Tiada",
      status: "Status",
      actions: "Tindakan",
      details: "Butiran",
      date: "Tarikh",
      time: "Masa",
      name: "Nama",
      email: "Emel",
      password: "Kata Laluan",
      login: "Log Masuk",
      logout: "Log Keluar",
      register: "Daftar",
      login_title: "Log Masuk",
      login_subtitle: "Masukkan butiran anda untuk meneruskan",
      register_title: "Daftar Akaun",
      forgot_password: "Lupa Kata Laluan?",
      remember_me: "Ingat Saya",
      demo_credentials: "Demo Credentials",
      nav_dashboard: "Papan Utama",
      nav_branches: "Cawangan",
      nav_staff: "Staf",
      nav_schedule: "Jadual",
      nav_leave: "Cuti",
      nav_reports: "Laporan",
      nav_payslip: "Slip Gaji",
      nav_analytics: "Analitik",
      nav_settings: "Tetapan",
      nav_announcements: "Pengumuman",
      nav_holidays: "Cuti Umum",
      nav_overtime: "Kerja Lebih",
      nav_shift_swap: "Tukar Shift",
      dashboard_title: "Papan Utama",
      dashboard_welcome: "Selamat datang ke sistem pengurusan kehadiran staf",
      total_staff: "Jumlah Staf",
      present_today: "Hadir Hari Ini",
      late_today: "Lewat Hari Ini",
      on_time_rate: "Kadar Tepat Masa",
      today_attendance: "Kehadiran Hari Ini",
      quick_actions: "Tindakan Pantas",
      clock_in: "Clock In",
      clock_out: "Clock Out",
      not_clocked_in: "Belum Clock In",
      currently_working: "Sedang Bekerja",
      completed_today: "Selesai Hari Ini",
      clock_in_time: "Masa Masuk",
      clock_out_time: "Masa Keluar",
      location_detected: "Lokasi Dikesan",
      location_not_detected: "Lokasi Tidak Dikesan",
      within_geofence: "Dalam Kawasan Cawangan",
      outside_geofence: "Di Luar Kawasan Cawangan",
      enable_gps: "Sila aktifkan GPS",
      distance: "Jarak",
      radius_limit: "Had Radius",
      branch_management: "Pengurusan Cawangan",
      branch_name: "Nama Cawangan",
      branch_address: "Alamat",
      branch_coordinates: "Koordinat",
      branch_radius: "Radius Geo-Lock",
      add_branch: "Tambah Cawangan",
      edit_branch: "Edit Cawangan",
      delete_branch: "Padam Cawangan",
      select_location: "Pilih lokasi pada peta",
      current_location: "Lokasi Semasa",
      staff_management: "Pengurusan Staf",
      staff_name: "Nama Staf",
      staff_email: "Emel Staf",
      staff_branch: "Cawangan",
      face_registered: "Wajah Didaftar",
      face_not_registered: "Wajah Belum Didaftar",
      work_start_time: "Waktu Mula Kerja",
      leave_balance: "Baki Cuti",
      leave_application: "Permohonan Cuti",
      leave_management: "Pengurusan Cuti",
      leave_type: "Jenis Cuti",
      annual_leave: "Cuti Tahunan (AL)",
      sick_leave: "Cuti Sakit (MC)",
      leave_start: "Tarikh Mula",
      leave_end: "Tarikh Tamat",
      leave_reason: "Sebab Cuti",
      leave_days: "Bilangan Hari",
      relief_teacher: "Guru Ganti",
      bank_info: "Maklumat Bank",
      pending: "Menunggu",
      approved: "Diluluskan",
      rejected: "Ditolak",
      approve: "Lulus",
      reject: "Tolak",
      rejection_reason: "Sebab Penolakan",
      daily_schedule: "Jadual Harian",
      add_schedule: "Tambah Jadual",
      shift_morning: "Shift Pagi",
      shift_evening: "Shift Petang",
      shift_night: "Shift Malam",
      attendance_reports: "Laporan Kehadiran",
      cross_check_report: "Laporan Cross-Check",
      scheduled_time: "Jadual",
      actual_time: "Sebenar",
      on_time: "Tepat Masa",
      late: "Lewat",
      absent: "Tidak Hadir",
      late_minutes: "Minit Lewat",
      total_records: "Jumlah Rekod",
      export_pdf: "Eksport PDF",
      export_excel: "Eksport Excel",
      export_csv: "Eksport CSV",
      export_word: "Eksport Word",
      payslip_generator: "Penjana Slip Gaji",
      select_staff: "Pilih Staf",
      select_month: "Pilih Bulan",
      preview_payslip: "Pratonton Slip Gaji",
      basic_salary: "Gaji Pokok",
      overtime_pay: "Bayaran OT",
      allowance: "Elaun",
      gross_salary: "Jumlah Pendapatan",
      deductions: "Potongan",
      net_salary: "Gaji Bersih",
      analytics_title: "Analitik & Statistik",
      monthly_trend: "Trend Bulanan",
      attendance_overview: "Gambaran Kehadiran",
      performance_metrics: "Metrik Prestasi",
      department_comparison: "Perbandingan Cawangan",
      overtime_management: "Pengurusan Kerja Lebih",
      ot_request: "Permohonan OT",
      ot_hours: "Jam OT",
      ot_rate: "Kadar OT",
      ot_amount: "Jumlah OT",
      ot_date: "Tarikh OT",
      ot_reason: "Sebab OT",
      shift_swap_title: "Permohonan Tukar Shift",
      swap_with: "Tukar Dengan",
      swap_date: "Tarikh Tukar",
      swap_reason: "Sebab Tukar",
      swap_status: "Status Permohonan",
      public_holidays: "Cuti Umum",
      holiday_name: "Nama Cuti",
      holiday_date: "Tarikh",
      add_holiday: "Tambah Cuti Umum",
      announcements: "Pengumuman",
      announcement_title: "Tajuk",
      announcement_content: "Kandungan",
      add_announcement: "Tambah Pengumuman",
      pinned: "Disematkan",
      offline_mode: "Mode Offline",
      offline_message: "Anda sedang offline. Data akan disegerakkan bila online.",
      sync_pending: "Menunggu segerakan",
      last_synced: "Terakhir disegerak",
      error_occurred: "Ralat berlaku",
      try_again: "Cuba Semula",
      no_data: "Tiada data",
      no_records: "Tiada rekod",
    }
  },
  en: {
    translation: {
      app_name: "Rekod & Pengurusan Staff",
      welcome: "Welcome",
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      search: "Search",
      filter: "Filter",
      export: "Export",
      download: "Download",
      close: "Close",
      submit: "Submit",
      confirm: "Confirm",
      back: "Back",
      next: "Next",
      yes: "Yes",
      no: "No",
      all: "All",
      none: "None",
      status: "Status",
      actions: "Actions",
      details: "Details",
      date: "Date",
      time: "Time",
      name: "Name",
      email: "Email",
      password: "Password",
      login: "Login",
      logout: "Logout",
      register: "Register",
      login_title: "Sign In",
      login_subtitle: "Enter your details to continue",
      register_title: "Create Account",
      forgot_password: "Forgot Password?",
      remember_me: "Remember Me",
      demo_credentials: "Demo Credentials",
      nav_dashboard: "Dashboard",
      nav_branches: "Branches",
      nav_staff: "Staff",
      nav_schedule: "Schedule",
      nav_leave: "Leave",
      nav_reports: "Reports",
      nav_payslip: "Payslip",
      nav_analytics: "Analytics",
      nav_settings: "Settings",
      nav_announcements: "Announcements",
      nav_holidays: "Public Holidays",
      nav_overtime: "Overtime",
      nav_shift_swap: "Shift Swap",
      dashboard_title: "Dashboard",
      dashboard_welcome: "Welcome to staff attendance management system",
      total_staff: "Total Staff",
      present_today: "Present Today",
      late_today: "Late Today",
      on_time_rate: "On Time Rate",
      today_attendance: "Today's Attendance",
      quick_actions: "Quick Actions",
      clock_in: "Clock In",
      clock_out: "Clock Out",
      not_clocked_in: "Not Clocked In",
      currently_working: "Currently Working",
      completed_today: "Completed Today",
      clock_in_time: "Clock In Time",
      clock_out_time: "Clock Out Time",
      location_detected: "Location Detected",
      location_not_detected: "Location Not Detected",
      within_geofence: "Within Branch Area",
      outside_geofence: "Outside Branch Area",
      enable_gps: "Please enable GPS",
      distance: "Distance",
      radius_limit: "Radius Limit",
      branch_management: "Branch Management",
      branch_name: "Branch Name",
      branch_address: "Address",
      branch_coordinates: "Coordinates",
      branch_radius: "Geo-Lock Radius",
      add_branch: "Add Branch",
      edit_branch: "Edit Branch",
      delete_branch: "Delete Branch",
      select_location: "Select location on map",
      current_location: "Current Location",
      staff_management: "Staff Management",
      staff_name: "Staff Name",
      staff_email: "Staff Email",
      staff_branch: "Branch",
      face_registered: "Face Registered",
      face_not_registered: "Face Not Registered",
      work_start_time: "Work Start Time",
      leave_balance: "Leave Balance",
      leave_application: "Leave Application",
      leave_management: "Leave Management",
      leave_type: "Leave Type",
      annual_leave: "Annual Leave (AL)",
      sick_leave: "Sick Leave (MC)",
      leave_start: "Start Date",
      leave_end: "End Date",
      leave_reason: "Reason",
      leave_days: "Number of Days",
      relief_teacher: "Relief Teacher",
      bank_info: "Bank Information",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      approve: "Approve",
      reject: "Reject",
      rejection_reason: "Rejection Reason",
      daily_schedule: "Daily Schedule",
      add_schedule: "Add Schedule",
      shift_morning: "Morning Shift",
      shift_evening: "Evening Shift",
      shift_night: "Night Shift",
      attendance_reports: "Attendance Reports",
      cross_check_report: "Cross-Check Report",
      scheduled_time: "Scheduled",
      actual_time: "Actual",
      on_time: "On Time",
      late: "Late",
      absent: "Absent",
      late_minutes: "Late Minutes",
      total_records: "Total Records",
      export_pdf: "Export PDF",
      export_excel: "Export Excel",
      export_csv: "Export CSV",
      export_word: "Export Word",
      payslip_generator: "Payslip Generator",
      select_staff: "Select Staff",
      select_month: "Select Month",
      preview_payslip: "Preview Payslip",
      basic_salary: "Basic Salary",
      overtime_pay: "Overtime Pay",
      allowance: "Allowance",
      gross_salary: "Gross Salary",
      deductions: "Deductions",
      net_salary: "Net Salary",
      analytics_title: "Analytics & Statistics",
      monthly_trend: "Monthly Trend",
      attendance_overview: "Attendance Overview",
      performance_metrics: "Performance Metrics",
      department_comparison: "Branch Comparison",
      overtime_management: "Overtime Management",
      ot_request: "OT Request",
      ot_hours: "OT Hours",
      ot_rate: "OT Rate",
      ot_amount: "OT Amount",
      ot_date: "OT Date",
      ot_reason: "OT Reason",
      shift_swap_title: "Shift Swap Request",
      swap_with: "Swap With",
      swap_date: "Swap Date",
      swap_reason: "Swap Reason",
      swap_status: "Request Status",
      public_holidays: "Public Holidays",
      holiday_name: "Holiday Name",
      holiday_date: "Date",
      add_holiday: "Add Holiday",
      announcements: "Announcements",
      announcement_title: "Title",
      announcement_content: "Content",
      add_announcement: "Add Announcement",
      pinned: "Pinned",
      offline_mode: "Offline Mode",
      offline_message: "You are offline. Data will sync when online.",
      sync_pending: "Sync pending",
      last_synced: "Last synced",
      error_occurred: "Error occurred",
      try_again: "Try Again",
      no_data: "No data",
      no_records: "No records",
    }
  }
};

const savedLang = localStorage.getItem('destiny_language') || 'ms';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: 'ms',
    interpolation: { escapeValue: false }
  });

export default i18n;
